import {ReactComponent as WEIGHTAGE_ICON} from "../images/weightage_purple.svg"
import {ReactComponent as CHECK_ICON} from "../images/check_marker_purple.svg"
import {
    CUSTOM_TEXT,
    POINT_TEXT,
    POINTS_TEXT,
    QUESTION_MAX_POINTS,
    UNGRADED_Cap,
} from "../utils/constants";
import {useEffect, useId, useRef, useState} from "react";
import classes from "./Dropdown.module.css";
import {YuJaTooltip} from "./standardization/YuJaTooltip";
import {QUESTION_POINTS_RANGE_ERROR, QUESTION_TOTAL_POINTS_RANGE_ERROR} from "../utils/toast-message-constants";
import {notifyError} from "../utils/helpers";
import YuJaSelect from "./standardization/YuJaSelect";

export default function DropdownWeightage({
                                              setWeightage, weightage, defaultWidth=160,
                                              maxVal=QUESTION_MAX_POINTS,
                                              showIcon=true,
                                              dropdownStyle={},
                                              upIcon=null,
                                              downIcon=null,
}) {
    let uniqueId = useId();
    const [isSelectedCustom, setIsSelectedCustom] = useState(false);
    const inputRef = useRef();
    const [inputVal, setInputVal] = useState("");

    const options = [
        {label: UNGRADED_Cap, value: "0"},
        {label: "1 " + POINT_TEXT, value: "1"},
        {label: "3 " + POINTS_TEXT, value: "3"},
        {label: "5 " + POINTS_TEXT, value: "5"},
        {label: CUSTOM_TEXT, value: "-1"},
    ];

    const translateDropdownValue = (weightage) => {
        if (!weightage || isNaN(weightage)) {
            return "0";
        }

        if (weightage === 1 || weightage === 3 || weightage === 5) {
            return weightage.toString();
        }

        return "-1";
    }


    useEffect(() => {
        if (isSelectedCustom) {
            let input = document.getElementById(`input-${uniqueId}`);
            if (!!input) {
                input.focus();
            }
        }
    }, [isSelectedCustom]);

    const onChangeCustomInput = (e) => {
        let input = e.target.value;

        let result = '';
        for (let i = 0; i < input.length; i++) {
            const char = input[i];
            if (/\d/.test(char)) {
                result += char;
            }
        }

        setInputVal(result);
    }


    const onBlur = (e) => {
        if (e.target.value !== undefined && e.target.value !== "") {
            let val = parseInt(e.target.value);
            if (val > maxVal) {
                setWeightage(maxVal);
                notifyError(maxVal === QUESTION_MAX_POINTS
                    ? QUESTION_POINTS_RANGE_ERROR : QUESTION_TOTAL_POINTS_RANGE_ERROR);
            } else if (val < 0) {
                setWeightage(0);
                notifyError(maxVal === QUESTION_MAX_POINTS
                    ? QUESTION_POINTS_RANGE_ERROR : QUESTION_TOTAL_POINTS_RANGE_ERROR);
            } else {
                setWeightage(val);
            }

        } else {
            setWeightage(0);
        }
        setIsSelectedCustom(false);
    }

    const customPresenter = () => {
        let val = translateDropdownValue(weightage);
        if (val === "-1") {
            return weightage + " Points";
        } else {
            return options.find(opt => opt.value === val).label;
        }
    }



    return (
        <div style={{position: 'relative', width: defaultWidth,}}>
            <div
                className={classes.inputContainer}
                style={{visibility: isSelectedCustom ? "visible" : "hidden", ...dropdownStyle}}
            >
                {showIcon && <span className={classes.icon}><WEIGHTAGE_ICON/></span>}

                <YuJaTooltip placement={"bottom"} text={"Enter points"}>
                    <input
                        id={`input-${uniqueId}`}
                        ref={inputRef}
                        value={inputVal}
                        onChange={onChangeCustomInput}
                        onBlur={onBlur}
                        placeholder={"  " + POINTS_TEXT}
                    />
                </YuJaTooltip>
                {isSelectedCustom &&
                    <CHECK_ICON style={{cursor: "pointer"}} title={"confirm"}/>
                }
            </div>


            <YuJaSelect
                ariaLabel={"Points"}
                style={{...dropdownStyle, width: defaultWidth, padding: "0 10px"}}
                downIcon={downIcon}
                options={options}
                value={translateDropdownValue(weightage)}
                onChange={val => {
                    if (val === "-1") {
                        setIsSelectedCustom(true);
                        setInputVal(translateDropdownValue(weightage) !== "-1" ? "" : weightage);
                    } else {
                        setWeightage(parseInt(val));
                    }

                }}
                presenterIcon={showIcon ? <span className={classes.icon}><WEIGHTAGE_ICON/></span> : <></>}
                customPresenter={customPresenter}
            />
        </div>
    );
}